module.exports = __webpack_public_path__ + "static/media/appointment-list.49554e0c.svg";